import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {AuthService} from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(
    private router: Router,
    private authService: AuthService
  ) {
  }

  /**
   * Activation waits for server-backed verification (#34).
   *
   * The previous implementation returned `true` for any cookie that merely contained a token
   * string, so a session that had expired hours earlier still opened the Product Catalog.
   * Because this now returns an Observable that does not emit until `/auth/verify` answers,
   * the routed component is not instantiated — and therefore issues no data request — until
   * the session is known to be valid. Cleanup of a rejected session has already happened
   * inside the validation path by the time `false` arrives.
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.authService.ensureSessionValidated().pipe(
      map(isValid => isValid
        ? true
        : this.router.createUrlTree(['/login'], {
          queryParams: {returnUrl: state.url},
        }))
    );
  }
}
